module.exports = __webpack_public_path__ + "img/userico.230dcc21.svg";